import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RsMotionModule } from './motion';
import { ServiceCtaComponent } from './service-cta/service-cta.component';
import { ConsultFormComponent } from './consult-form/consult-form.component';

const component = [BannerComponent];
const modules = [
  SlickCarouselModule,
  // design-system motion directives (rsReveal / rsRipple / rsCountUp / rsParallax
  // / rsServiceTimeline)
  RsMotionModule,
  // shared closing CTA for the service pages
  ServiceCtaComponent,
  // the consultation card the banner renders in its aside slot
  ConsultFormComponent
];

@NgModule({
  declarations: [...component], // spread the array
  imports: [CommonModule, ...modules, FormsModule, ReactiveFormsModule], // spread modules array too
  exports: [...component, ...modules], // spread here as well
})
export class SharedModule {}
